import apiClient from '../api';

const API_PATH = '/customer-access';

// Get all access permissions (filtered by company for company_admin)
export const getAllAccessPermissions = () => {
  return apiClient.get(API_PATH);
};

// Get all access permissions for a specific user
export const getUserAccessPermissions = (userId) => {
  return apiClient.get(`${API_PATH}/user/${userId}`);
};

// Get all access permissions for a specific customer
export const getCustomerAccessPermissions = (customerId) => {
  return apiClient.get(`${API_PATH}/customer/${customerId}`);
};

// Grant access to a user for a customer
export const grantAccess = (userId, customerId) => {
  return apiClient.post(API_PATH, { userId, customerId });
};

// Revoke access permission
export const revokeAccess = (accessId) => {
  return apiClient.delete(`${API_PATH}/${accessId}`);
};

// Bulk grant access to a user for multiple customers
export const bulkGrantAccess = (userId, customerIds) => {
  return apiClient.post(`${API_PATH}/bulk/grant`, { userId, customerIds });
}; 